module.exports = __webpack_public_path__ + "img/C904.7db802bd.jpg";